import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

import styles from "./styles.module.css";
import { useVideoPlayerRefs } from "../../contexts/VideoPlayerRefs";
import { useRoot } from "../../contexts/Root";
import { useStreamingState } from "../../contexts/StreamingState";
import { StreamingState } from "../../types/streamingState";

export const Poster = () => {
  const { autoplay, poster: src } = useRoot();
  const { video } = useVideoPlayerRefs();
  const { streamingState } = useStreamingState();

  const show =
    !autoplay &&
    (streamingState === StreamingState.loaded ||
      streamingState === StreamingState.loading);

  const onClick = async () => {
    await video.current?.play();
  };

  const [isPosterHovering, setIsPosterHovering] = useState(false);

  const posterContainer = `${styles.container} ${
    !show && styles.containerHide
  }`;

  const posterIcon = `${styles.playIcon} ${
    isPosterHovering && styles.playIconHover
  }`;

  return (
    <div
      className={posterContainer}
      role="button"
      tabIndex={0}
      onKeyDown={undefined}
      onClick={onClick}
      onMouseEnter={() => {
        setIsPosterHovering(true);
      }}
      onMouseLeave={() => {
        setIsPosterHovering(false);
      }}
    >
      <img
        crossOrigin="anonymous"
        alt=""
        key={src}
        src={src}
        className={styles.img}
      />
      <FontAwesomeIcon icon={faPlay} className={posterIcon} />
    </div>
  );
};
